import dayjs from "dayjs";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { commonString } from "../../../AdminApi/commFunc";
import { getThousandComma } from "../../../ApiTS/ApiCommonTS";
import LineBtn from "../../../components/Button/LineBtn";
import LineBox from "../../../components/DefaultStyles/LineBox";
import Loader from "../../../components/DefaultStyles/Loader";
import PageTitle from "../../../components/DefaultStyles/PageTitle";
import SpaceBetween from "../../../components/DefaultStyles/SpaceBetween";
import NoticeFilter from "../../../components/pages/LinkidManage/Notice/NoticeFilter";
import Pagination from "../../../components/Table/Pagination";
import Table, {
  TableBody,
  TableBodyItem,
} from "../../../components/Table/Table";
import { useApi } from "../../../hooks/useApi";
import { TotalCount } from "../../Users/UserInfo";

interface INotice {
  id: number;
  isPublic: number;
  isTop: number;
  title: string;
  updatedate: string;
  viewcount: number;
  admin: string;
  category: string;
  content: string;
}

export default function Notice() {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const [page, setPage] = useState(0);
  const [filter, setFilter] = useState({
    categoryId: 0,
    orderByViewCount: "id",
    ispublic: 2,
    isTop: 2,
  });

  const isNotice = pathname?.includes("notice");

  const { response, loading, error } = useApi({
    method: "get",
    url:
      `notice?isNotice=${isNotice ? 1 : 0}&page=${page}&size=10` +
      (filter?.categoryId > 0 ? `&categoryId=${filter?.categoryId}` : ``) +
      (filter?.ispublic < 2 ? `&ispublic=${filter.ispublic}` : ``) +
      (filter?.isTop < 2 ? `&isTop=${filter.isTop}` : ``) +
      `&orderBy=${filter?.orderByViewCount}`,
  });

  const noticeTableHead = [
    "No.",
    "카테고리",
    "제목",
    "공개 여부",
    isNotice ? "상단 고정" : undefined,
    "작성자",
    "작성일시",
    "조회수",
    "상세",
  ];

  useEffect(() => {
    if (error?.data) {
      toast.error(
        error?.data ?? `${commonString(pathname).title} 조회에 실패하였습니다.`
      );
    }
  }, [error]);

  return (
    <>
      <PageTitle title={commonString(pathname).title} />

      <NoticeFilter setFilter={setFilter} />

      <LineBox>
        <Table tableHeadData={noticeTableHead}>
          <>
            {response?.data?.items?.map((d: INotice, index: number) => (
              <TableBody>
                <TableBodyItem>{d?.id ?? 0}</TableBodyItem>
                <TableBodyItem>{d?.category ?? "-"}</TableBodyItem>
                <TableBodyItem>{d?.title ?? "-"}</TableBodyItem>
                <TableBodyItem>
                  {d?.isPublic === 1 ? "공개" : "비공개"}
                </TableBodyItem>
                {isNotice && (
                  <TableBodyItem>
                    {d?.isTop === 1 ? "상단 고정" : "-"}
                  </TableBodyItem>
                )}
                <TableBodyItem>{d?.admin ?? "-"}</TableBodyItem>
                <TableBodyItem>
                  {dayjs(d?.updatedate ?? undefined).format(
                    "YYYY-MM-DD HH:mm:ss"
                  )}
                </TableBodyItem>
                <TableBodyItem>
                  {getThousandComma(d?.viewcount ?? 0)}
                </TableBodyItem>
                <TableBodyItem>
                  <LineBtn
                    btnText="상세"
                    btnClickEvent={() =>
                      navigate(
                        `/linkid-manage/${commonString(pathname).route}/${
                          d?.id ?? 0
                        }`
                      )
                    }
                  />
                </TableBodyItem>
              </TableBody>
            ))}
          </>
        </Table>

        <SpaceBetween>
          <Pagination
            totalPage={response?.status === 200 ? response.data.totalPage : 1}
            currentPage={page}
            pageClickEvent={(index) => setPage(index)}
          />

          <TotalCount>
            총{" "}
            {getThousandComma(
              response?.status === 200 ? +response?.data?.totalCount : 0
            )}
            개
          </TotalCount>
        </SpaceBetween>
      </LineBox>

      {loading && <Loader />}
    </>
  );
}
